import { isEqual } from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

// Lightweight safe comparison. Avoid JSON stringify cloning (very expensive) which
// showed up as a multi-second hotspot in performance traces. If lodash's
// isEqual throws (e.g., due to revoked proxies), we fall back to strict
// equality or return false. This keeps selectors fast and non-blocking.
const safeIsEqual = (a: unknown, b: unknown): boolean => {
  if (a === b) return true;
  if (a == null || b == null) return a === b;
  try {
    return isEqual(a, b);
  } catch {
    return false;
  }
};

// Create a "selector creator" that uses our safe comparison function
export const createDeepEqualSelector = createSelectorCreator(
    defaultMemoize,
    safeIsEqual
)